import { render, staticRenderFns } from "./GridSertec.vue?vue&type=template&id=c02875b4&"
import script from "./GridSertec.vue?vue&type=script&lang=ts&"
export * from "./GridSertec.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c02875b4', component.options)
    } else {
      api.reload('c02875b4', component.options)
    }
    module.hot.accept("./GridSertec.vue?vue&type=template&id=c02875b4&", function () {
      api.rerender('c02875b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/DatosSertec/GridSertec.vue"
export default component.exports